import num2persian from 'num2persian';
// import i18n from '../plugins/i18n';

const priceToRialPhrase = (number) => {
    const phrase = num2persian(number);
    return `${phrase} ریال`;
};

const priceToTomanPhrase = (number) => {
    number = parseInt(number / 10);
    const phrase = num2persian(number);
    return `${phrase} تومان`;
};

export {
    priceToRialPhrase,
    priceToTomanPhrase
};